const initialstate = {
  data:[],
  reportdata:[],
  
};

const OrgFundReportsReducers =  (state = initialstate, action:any)=>{
  switch (action.type){
      case 'fetch_data_success':
          return {... state, data:action.payload};
          case 'fetch_report_data_success':
          return {... state, reportdata:action.payload};
                     default :
          return state;
  }
};
export default OrgFundReportsReducers;